/* eslint-disable @typescript-eslint/no-require-imports */
const vue3Stub = require('@/stubs/vue3.cjs');
export const vue3 = vue3Stub;
